<template>
  <div class="formTop page-reminds">
    <div class="topNav">
      <ShowNavHead />
      <div class="dateSelect">
        <div class="eventSelectNav">
          <div class="eventType" v-for="(event,index) in list" :key="index" v-bind:class="{selected:isActive==index}" @click="checkItem(event,index)">{{event.name}}</div>
        </div>
      </div>
      <div class="textBox">
        <!-- <transition name="slide">
         <p class="text" :key="text.id">{{text.val}}</p>
        </transition> -->
      </div>
      <div class="remindListTopRight" style="margin-right:15px">
        <!-- <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
        </el-button> -->
        <div class="topInput">
          <el-input v-model.trim="strempname" placeholder="请输入项目名称或姓名" clearable @change="setInputVal" @keyup.enter.native="searchEnterFun" style="width:319px"></el-input>
          <el-button type="success" plain size="small" @click="searchEnterFun" style="margin-left:10px">搜索</el-button>
          <el-button type="primary" plain size="small" @click="exportFun" :loading="exportStatus" style="margin-left:10px" v-if="isActive!='2'">导出</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftNum: this.$store.state.menu.leftNum,
      strempname: "",
      isActive: 0,
      event: "",
      eventType: "",
      //下拉筛选
      showDropScreen: -1,
      isHandled: 0,
      // eventTypeSelect: [
      //   {
      //     name: "16周岁",
      //     value: "pending"
      //   },
      //   {
      //       name: "18周岁",
      //       value: "pending"
      //   },
      //   {
      //     name: "已处理",
      //     value: "processed"
      //   }
      // ],
      // textArr: [
      //   '1 第一条公告',
      //   '2 第二条公告第二条公告',
      //   '3 第三条公告第三条公告第三条公告'
      // ],
      number: 0
    };
  },
  props: {
    'exportStatus': Boolean,
    list: {
      type: Array,
      default: function () {
        return [
          {
            name: "16周岁以下",
            value: "0"
          },
          {
            name: "16~18周岁",
            value: "1"
          },
          {
            name: "已处理",
            value: "2"
          }
        ]
      }
    }
  },
  computed: {
    // text () {
    //   return {
    //     id: this.number,
    //     val: this.textArr[this.number]
    //   }
    // }
  },
  watch: {
    '$store.state.menu.leftNum': function () {
      this.leftNum = this.$store.state.menu.leftNum;
      if (this.leftNum) {
        if (this.leftNum.msg.yong16cont == 0) {
          if (this.leftNum.msg.yong18cont != 0) {
            // console.log('daqaq', this.leftNum)
            this.isActive = 1;
            this.$emit('event3', 1)
            this.searchEnterFun();
          }
        }
      }
    }
  },
  mounted() {
    this.$store.commit("getLeftNum");
    this.startMove()
  },
  methods: {
    //导出
    async exportFun(){
      this.$emit('exportMethod')
    },
    setInputVal() {
      this.$emit('transformVal', this.strempname)
    },
    //事件是否处理选择
    checkItem(event, index) {
      console.log(event, index)
      this.isActive = index;
      this.eventType = event.value;
      this.$emit('event3', index)
      this.searchEnterFun();
    },
    //搜索
    searchEnterFun() {
      this.$emit('fatherMethod');
    },
    //筛选下拉
    // dropDownScreen(){
    //  if( this.showDropScreen == -1){
    //     this.showDropScreen = 1
    //  }else if( this.showDropScreen == 1){
    //     this.showDropScreen = -1
    //  }
    // },
    startMove() {
      // eslint-disable-next-line
      let timer = setTimeout(() => {
        if (this.number === 2) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 2000); // 滚动不需要停顿则将2000改成动画持续时间
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.textBox {
  width: 220px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.text {
  width: 500px;
  position: absolute;
  bottom: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
</style>

<style >
.page-reminds .topInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 100%!important;
}
.topInput .el-input__icon {
  /* margin-top: 10px; */
  height: 32px;
  line-height: 32px;
}
</style>
